import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const BonusEngineIcon = observer(
    'BonusEngineIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='28'
            height='28'
            viewBox='0 0 28 28'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                stroke='#E4E4E7'
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M21.105 12.098A7 7 0 1 1 12.063 21M8.167 7h1.166v4.667m10.162 4.526.817.829-3.29 3.29m-.689-10.979a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z'
            />
        </SvgElement>
    )
);
